<!--
 * @Author: your name
 * @Date: 2021-02-19 11:22:33
 * @LastEditTime: 2021-06-25 17:17:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \standard-business\client\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'; 
export default {
  name: 'App',
  created() {
    // 刷新时获取sellerBookingType状态
    const hasToken = getToken();
    let sellerBookingType = window.localStorage.getItem('sellerBookingType');
    if (hasToken && sellerBookingType !== null) {
      sellerBookingType = parseInt(sellerBookingType);
      this.$store.dispatch('app/setBusinessType', {
        type: sellerBookingType ? 1 : 0,
      });
    }
  },
};
</script>
<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

// .item-scroll {
//   overflow-x: scroll;
//   &::-webkit-scrollbar {
//     height: 11px;
//     width: 500px;
//     background: white;
//   }
//   &::-webkit-scrollbar-corner, /* 滚动条角落 */
//             &::-webkit-scrollbar-thumb,
//             &::-webkit-scrollbar-track {
//     border-radius: 14px;
//   }
//   &::-webkit-scrollbar-corner,
//   &::-webkit-scrollbar-track {
//     /* 滚动条轨道 */
//     background-color: rgba(180, 160, 120, 0.1);
//     box-shadow: inset 0 0 1px rgba(180, 160, 120, 0.5);
//   }
//   &::-webkit-scrollbar-thumb {
//     /* 滚动条手柄 */
//     background-color: #bfbfbf;
//   }
// }

.data-overview-name {
  margin-top: 10px;
  height: 25px;
  line-height: 25px;
  border-bottom: 1px solid rgb(221, 221, 221);
  margin-bottom: 10px;
  position: relative;
  div {
    height: 25px;
    position: absolute;
    top: 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      display: inline-block;
      height: 25px;
      line-height: 25px;
      margin-left: 15px;
    }
  }

  &::before {
    content: '';
    display: inline-block;
    height: 25px;
    width: 6px;
    background-color: #cacaca;
  }
}

.cascader-view {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
</style>
